import React, {useEffect} from 'react';
import {DefaultLayout} from '../layout/DefaultLayout';
import { Spinner } from '../components/Spinner';
import { useParams, useNavigate } from 'react-router-dom';

export default function DownloadCsv() {
  const { fileName } = useParams<{ fileName: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!fileName) return;
    const url = `/data/exports/${fileName}`;
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    // Then redirect back to admin page
    setTimeout(() => {
      navigate('/admin/data');
    }, 200);
  }, [fileName, navigate]);

  return (
    <DefaultLayout>
      <Spinner />
    </DefaultLayout>
  );
}
